<template>
    <v-card v-if="liga" :flat="$vuetify.breakpoint.smAndDown" >
        <v-card-title>
            <v-row align="center">
                <v-col class="grow text">
                    {{liga.nameFull}}
                    <span v-if="$vuetify.breakpoint.smAndUp">{{sportJahrText}}</span>
                    <span v-if="liga.keineDoppelstartKontrolle">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon v-on="on" v-bind="attrs" color="primary"
                                        class="ml-3">
                                    mdi-eye-off
                                </v-icon>
                            </template>
                            <span>Die Doppelstart-Kontrolle ist für diese Liga deaktiviert!</span>
                        </v-tooltip>
                    </span>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <span v-on="on" v-bind="attrs" class="ml-3 strikeThrough">
                                <v-icon v-if="liga.noRanking"
                                         color="primary">
                                    mdi-format-list-numbered
                                </v-icon>
                            </span>
                        </template>
                        <span>Für diese Liga wird keine Tabelle berechnet!</span>
                    </v-tooltip>
                </v-col>
                <v-col class="shrink">
                    <liga-edit-menu @ligaAction="ligaAction"
                                    :saisonExisting="saisonRaw">
                    </liga-edit-menu>
                </v-col>
            </v-row>
        </v-card-title>
        <v-card-subtitle>
            {{landesverband.nameShort.trim()}}
            <span v-if="$vuetify.breakpoint.xsOnly"> - {{sportJahrText}}</span>
        </v-card-subtitle>
        <v-card-text :class="[{'px-0': $vuetify.breakpoint.smAndDown}]">
        <!-- binding -->
            <div v-if="$store.state.local.bindsRealtimeList" class="text-center">
                <v-progress-circular indeterminate color="primary" class="my-5"></v-progress-circular>
            </div>
        <!-- no season -->
            <liga-no-season v-else-if="!saisonRaw" :sport-jahr="sportJahr" @ligaAction="ligaAction">
            </liga-no-season>
        <!-- season existing -->
            <saison-component v-else :saison="saison" :noRanking="noRanking" :isCup="liga.isCup">
            </saison-component>
        </v-card-text>
    <!-- overlays -->
        <!-- edit saison -->
            <saison-edit v-if="$route.query.action==='editSaison'" :is-cup="liga.isCup"
                         :currentData="saisonRaw" :sportJahr="sportJahr" :ligaId="ligaId">
            </saison-edit>
            <saison-edit-frist v-if="$route.query.action==='editSaisonFrist'"
                               :currentData="saisonFristRaw" :sportJahr="sportJahr" :ligaId="ligaId">
            </saison-edit-frist>
            <saison-edit-table v-if="$route.query.action==='editSaisonTable'"
                               :currentData="saisonRaw" :sportJahr="sportJahr">
            </saison-edit-table>
            <info-container header-text="Vereinsdatenblätter" :width="950"
                            action="displayVereinsdatenblaetter"
                            :valid-actions="['displayVereinsdatenblaetter']"
                            header-icon="mdi-information-outline">
                <vereinsdatenblatt-liste :saison="saison"></vereinsdatenblatt-liste>
            </info-container>
            <!--v-if="$route.query.action==='displayVereinsdatenblaetter'"-->
    </v-card>
</template>

<script>
    import LigaEditMenu from "./ligaEditMenu";
    import {db} from "../../services/db";
    import LigaNoSeason from "./ligaNoSeason";
    import {Saison} from "../../services/data/saison";
    import SaisonEdit from "./saisonEdit";
    import SaisonComponent from "./saison";
    import InfoContainer from "../../components/form/infoContainer";
    import VereinsdatenblattListe from "./vereinsdatenblatt/vereinsdatenblattListe";
    import SaisonEditFrist from "./saisonEditFrist";
    import SaisonEditTable from "./saisonEditTable";

    export default {
        components: {
            SaisonEditTable,
            SaisonEditFrist,
            VereinsdatenblattListe,
            InfoContainer,
            SaisonComponent,
            SaisonEdit,
            LigaNoSeason,
            LigaEditMenu,},
        name: "liga",
        props: ['sportJahr', 'landesverband', 'liga'],
        created(){
            this.setLiga();
        },
        computed: {
            user(){ return this.$store.state.user; },
            ligaId(){ return this.$route.query.itemId; },
            lvId() { return this.$route.query.itemId ? parseInt(this.$route.query.itemId.split("_")[0]) : '';},
            landesverbaende() { return this.$store.state.realtime.landesverbaende; },
            lvLigen(){ return this.landesverbaende[this.lvId] ? this.landesverbaende[this.lvId].ligen : null; },
            noRanking(){
                return this.landesverbaende[this.lvId] ?
                    this.landesverbaende[this.lvId].ligen[this.ligaId].noRanking : false;
            },
            saisonId() { return this.ligaId + '_' + this.sportJahr },
            sportJahrText(){ return this.sportJahr.replace('_', '/') },
            //saisonen(){ return this.$store.state.realtime.saisonen },
            //saison(){ return this.saisonen[this.saisonId]; },
        },
        destroyed() {
            if ( this.unsubscribe ) {
                this.unsubscribe();
            }
        },
        data: () => ({
            //liga: null,
            saisonRaw: null,
            saisonFristRaw: null,
            saison: null,
            unsubscribe: null,
        }),
        methods: {
        // init liga, saisonRaw and saison
            setLiga(){
                this.saison = null;
                if ( this.landesverbaende[this.lvId] ) {
                    this.$store.state.local.bindsRealtimeList = true;
                    //this.liga = this.landesverbaende[this.lvId].ligen[this.ligaId];
                    if ( this.unsubscribe ) { this.unsubscribe(); }
                    this.unsubscribe = db.collection("saisonen").doc(this.saisonId)
                        .onSnapshot((doc) => {
                            this.saisonRaw = doc.data();
                            if ( this.saisonRaw ) { this.saisonRaw.id = doc.id; }
                            this.$store.state.local.bindsRealtimeList = false;
                        });
                }
            },
            setSaisonFrist(){
                if ( this.$store.state.snapshots.bestaetigungsfristen &&
                    this.$store.state.snapshots.bestaetigungsfristen.length > 0 ) {
                    const frist = this.$store.state.snapshots.bestaetigungsfristen
                        .find(frist => frist.id === this.saisonId);
                    this.saisonFristRaw = frist ? frist : '';
                }
            },
            setSaisonObject(){
                this.saison = new Saison();
                this.saison.setFromDataObject(this.saisonRaw);
            },
        // liga and saison action
            ligaAction(action){
                if ( action === 'displayVereinsdatenblaetter' ) {
                    this.openRoute('displayVereinsdatenblaetter');
                } else if ( action === 'editSaison' ) {
                    this.openRoute('editSaison');
                } else if ( action === 'editSaisonFrist' ) {
                    this.setSaisonFrist();
                    this.openRoute('editSaisonFrist');
                } else if ( action === 'editSaisonTable' ) {
                    //this.setSaisonFrist();
                    this.openRoute('editSaisonTable');
                } else if ( action === 'deleteSaisonGames' ) {
                    this.openRoute('deleteSaisonGames');
                } else if ( action === 'deleteSaison' ) {
                    //
                } else {
                    this.$emit('ligaAction', action);
                }
            },
                openRoute(action){
                    let p = JSON.parse(JSON.stringify(this.$route.path));
                    let q = JSON.parse(JSON.stringify(this.$route.query));
                    q.action = action;
                    this.$router.push({path: p, query: q});
                },
        },
        watch: {
            '$route.query.itemId'(){
                console.log ("WATCH $route.query.itemId", this.$route.query.itemId);
                this.setLiga();
            },
            lvLigen: {
                handler(to, from){
                    if ( !from ) {
                        console.log ("WATCH lvLigen", from);
                        this.setLiga();
                    }
                },
                deep: true
            },
            sportJahr(){
                console.log ("WATCH sportJahr", this.$route.query.itemId);
                this.setLiga();
            },
            saisonRaw(){
                if ( this.saisonRaw ) {
                    console.log ("WATCH saisonRaw", this.saisonRaw);
                    this.setSaisonObject();
                }
            },
        }
    }
</script>

<style scoped>
.strikeThrough{
    background:            linear-gradient(to top right,
            rgba(0,0,0,0) 0%,
            rgba(0,0,0,0) calc(50% - 1.5px),
            red 50%,
            rgba(0,0,0,0) calc(50% + 1.5px),
            rgba(0,0,0,0) 100%);}
</style>